import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getTemporaryMsgState = (state: RootState) => state.temporaryMsg;

export const getTemporaryMsgDataSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.temporaryMsgData,
);

export const getTemporaryMsgMediaFileInfoSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.temporaryMsgMediaFileInfo,
);

export const getTemporaryMsgStatusSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.temporaryMsgStatus,
);

export const getTemporaryMsgMediaFileStatusSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.temporaryMsgMediaFileStatus,
);

export const getTemporaryMsgPendingSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.isTMPending,
);

export const getTemporaryMsgErrorSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.isTMError,
);
export const getTemporaryMsgSaveSelector = createSelector(
  [getTemporaryMsgState],
  (temporaryMsg) => temporaryMsg?.isTMSave,
);
